// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationMailboxPath = 'M64 41h-7V26h-9.28A17.1 17.1 0 0151 36v25h40V36.5C91 30.701 86.299 26 80.5 26H64v15zm0-32v10h16.5c9.642.055 17.445 7.858 17.5 17.5V68H64v31H44V68H9v4H2V61h5V36h10.001c.105-8.49 6.369-15.669 14.799-16.9a17.097 17.097 0 013.105-.1H57V2h16v7h-9zM14 61h30v-9.186L32 59.1 14 48.13V61zm37 7v24h6V68h-6zM33 25.984V26h2.13a9.993 9.993 0 015.97 2.9A9.9 9.9 0 0144 36H23.994A10 10 0 0133 25.984zM32 50.9l12-7.273V43H19.03L32 50.9z';
var IllustrationMailbox = baseIllustration('IllustrationMailbox', {
  getPath: () => IllustrationMailboxPath
}, 'ColoredIllustrationMailbox');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationMailbox;
//# sourceMappingURL=index.js.map